module.exports = __webpack_public_path__ + "img/BE.d8bddc15.svg";